// ─────────────────────────────────────────────────────────────
// src/hooks/useOffline.js — online/offline detection hook
// ─────────────────────────────────────────────────────────────

import { useState, useEffect } from "react";

export function useOffline() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [justReconnected, setJustReconnected] = useState(false);

  useEffect(() => {
    function handleOffline() {
      setIsOffline(true);
      setJustReconnected(false);
    }

    function handleOnline() {
      setIsOffline(false);
      setJustReconnected(true);
      // Clear the "just reconnected" flag after 10s
      setTimeout(() => setJustReconnected(false), 10000);
    }

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  return { isOffline, justReconnected };
}
